import { ITimeAxesPlugin } from '@/shared/Charting/LineChart/lineChart.types.ts'
import axes from '@/shared/Charting/axes'
import LineChart from '@/shared/Charting/LineChart'

const AxesWithGridPlugin: () => ITimeAxesPlugin = () => ({
  chart: null as LineChart | null,
  yGrid: null,
  xGrid: null,
  init(chart: LineChart) {
    this.chart = chart
  },
  /* Отрисовка линий осей */
  onBeforeRender(ctx) {
    const len = 6
    const { zoom } = this.chart!

    this.xGrid = axes.calcTimeStep(zoom.xMax - zoom.xMin, zoom.xMin, len)
    const { start: xStart, step: xStep } = this.xGrid

    this.yGrid = axes.calcYGrid(zoom.yMin, zoom.yMax, len)

    ctx.fillStyle = '#000000A6'
    ctx.font = '12px Inter'
    ctx.strokeStyle = '#F5F5F5'
    ctx.beginPath()

    for (let i = 0; i < len; i++) {
      const ts = xStart + i * xStep
      if (ts > this.chart.zoom.xMax) continue

      const x = this.chart.getX(ts)
      ctx.moveTo(x, this.chart.paddings.top)
      ctx.lineTo(x, this.chart.canvas.height - this.chart.paddings.bottom)
    }

    for (let i = 0; i < len; i++) {
      const value = this.yGrid.values[i]
      const y = this.chart.getY(value)

      ctx.moveTo(this.chart.paddings.left, y)
      ctx.lineTo(this.chart.canvas.width - this.chart.paddings.right, y)
    }

    ctx.stroke()
    ctx.closePath()
  },
  /* Отрисовка подписей к осям */
  onAfterRender(ctx: CanvasRenderingContext2D) {
    ctx.fillStyle = '#000000A6'

    const len = 6

    const { start: xStart, step: xStep } = this.xGrid

    for (let i = 0; i < len; i++) {
      const ts = xStart + i * xStep
      if (ts > this.chart.zoom.xMax) continue

      const x = this.chart.getX(ts)

      const label = axes.getReadableTimeLabel(ts, this.chart.zoom.xMax - this.chart.zoom.xMin)
      if (label) {
        ctx.fillText(label, x - 15, this.chart.canvas.height - this.chart.padding + 20)
      }
    }

    for (let i = 0; i < len; i++) {
      const value = this.yGrid.values[i]
      if (value === undefined) continue

      const y = this.chart.getY(value)
      ctx.fillText(value.toFixed(2), this.chart.canvas.width - this.chart.padding + 8, y + 5)
    }
  },
})

export default AxesWithGridPlugin
